export const getSalaryToRules = (salaryFrom?: number) => ({
  validate: (value?: number) => {
    if (!value || salaryFrom === undefined) {
      return true;
    }
    return Number(value) >= Number(salaryFrom) || `Can’t be lower than ${salaryFrom} £`;
  },
});
